// headquarters.js
import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import FieldIcon from "../../utils/Register/field_icon";
import { useSelector } from "react-redux";
import { showToast } from "../../components/ToastNotification";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const defaultIcon = new L.Icon({
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const HeadquartersPopUp = ({ onClose, onSedeCreated }) => {
  const [location, setLocation] = useState({ lat: -0.94752, lng: -80.72245 });
  const [address, setAddress] = useState("");
  const [sedeName, setSedeName] = useState("");

  const token = useSelector((state) => state.user.token);

  const LocationMarker = () => {
    useMapEvents({
      click(e) {
        setLocation(e.latlng);
      },
    });

    return location ? <Marker position={location} icon={defaultIcon} /> : null;
  };

  const handleSaveSede = async (e) => {
    e.stopPropagation(); // Previene la propagación del evento
    e.preventDefault();

    if (!sedeName || !address || !location.lat || !location.lng) {
      showToast.error("Por favor, complete todos los campos.");
      return;
    }

    try {
      const response = await fetch(
        "https://server-postgre.vercel.app/api/sedes",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: sedeName,
            address,
            latitude: location.lat,
            longitude: location.lng,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Error al guardar la sede.");
      }

      const data = await response.json();
      showToast.success("Sede guardada con éxito");

      // Notificar al componente principal
      onSedeCreated({
        label: data.name,
        value: data.id,
      });

      onClose(); // Cierra solo si todo fue bien
    } catch (error) {
      showToast.error("Error al guardar la sede.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="w-[380px] bg-gradient-to-b from-orange-400 to-purple-500 p-6 rounded-3xl shadow-lg">
        <h2 className="text-center text-white text-lg font-bold mb-4">
          Nueva Sede
        </h2>
        <div className="bg-gradient-to-b from-purple-500 to-purple-700 p-4 rounded-3xl shadow-inner">
          <form>
            <FieldIcon
              id="sedeName"
              name="sedeName"
              type="text"
              autoComplete="on"
              placeholder="Nombre de la sede"
              value={sedeName}
              onChange={(e) => setSedeName(e.target.value)}
              required
              label="Nombre*"
            />
            <FieldIcon
              id="address"
              name="address"
              type="text"
              autoComplete="on"
              placeholder="Dirección de la sede"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
              label="Dirección*"
            />
          </form>
          <div className="mt-4 h-48 w-full rounded-lg overflow-hidden">
            <MapContainer
              center={location}
              zoom={14}
              style={{ width: "100%", height: "100%" }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap contributors"
              />
              <LocationMarker />
            </MapContainer>
          </div>
        </div>
        <div className="mt-4 text-center">
          <p>
            Latitud: {location.lat.toFixed(6)}, Longitud:{" "}
            {location.lng.toFixed(6)}
          </p>
          <button
            type="button"
            onClick={handleSaveSede}
            className="mt-2 bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
          >
            Guardar Ubicación
          </button>
        </div>
        <button
          onClick={onClose}
          className="mt-4 text-white text-sm underline hover:text-gray-300"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default HeadquartersPopUp;
